var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroku(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4274 0H13.4237C8.4547 0 4.41669 4.02695 4.41669 9.00703V91.0013C4.41669 95.973 8.4547 100 13.4237 100H85.4274C90.3978 100 94.4233 95.973 94.4233 91.0013V9.00703C94.4233 4.02695 90.3978 0 85.4274 0ZM89.4225 91.0013C89.4225 93.2091 87.6338 94.9964 85.4274 94.9964H13.4237C11.2186 94.9964 9.41752 93.2091 9.41752 91.0013V9.00703C9.41752 6.79089 11.2186 5.00083 13.4237 5.00083H85.4274C87.6338 5.00083 89.4225 6.79089 89.4225 9.00703V91.0013ZM26.9182 85.0057L38.176 75.0012L26.9182 64.9996V85.0057ZM67.5739 44.4678C65.5501 42.4329 61.8551 40.0023 55.6757 40.0023C48.8959 40.0023 41.9127 41.7689 36.9215 43.386V15.0051H26.9185V58.3692L33.9874 55.1667C34.105 55.1141 45.5011 50.0054 55.6757 50.0054C60.7512 50.0054 61.8759 52.7998 61.9298 55.1349V85.0057H71.9218V55.0062C71.9329 54.3643 71.8692 48.8157 67.5739 44.4678ZM54.4221 31.2517H64.4251C68.9445 26.1319 71.2478 20.6814 71.9229 15.0041H61.9296C60.816 20.6704 58.3522 26.089 54.4221 31.2517Z",
    fill: "#6762A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroku);
export default __webpack_public_path__ + "static/media/heroku.63685c91664246266e746581e8dab824.svg";
export { ForwardRef as ReactComponent };